// TOP LEVEL IMPORTS
import gql from 'graphql-tag';

export default gql`
  fragment organizationFragment on Organization {
    _id
    __typename
    title
    description
    email
    country
    currency
    state
    city
    zip
    website
    street1
    street2
    phone
    image
    salesTax
    sessionTypes {
      _id
      color
      title
    }
    stripeUserIdExists
    contactForm {
      firstName
      lastName
      phone
      email
      message
      venue
      eventDate
      eventType
      whereDidYouHearAboutUs
    }
  }
`;



// WEBPACK FOOTER //
// ./src/ApolloClient/Fragments/organizationFragment.js